import * as React from 'react';
import { displayPhoneNumber } from 'src/utils/utils';
import { IBaseInputProps, TextInput } from './TextInput';

export type IPhoneNumberTextInputProps = IBaseInputProps<string>;

export const PhoneNumberTextInput: React.FunctionComponent<
  IPhoneNumberTextInputProps
> = props => {
  const [formattedValue, setFormattedValue] = React.useState(
    formatValue(props.value)
  );

  React.useEffect(() => {
    if (deformatValue(formattedValue) !== props.value) {
      setFormattedValue(formatValue(props.value));
    }
  }, [props.value]);

  return (
    <TextInput
      {...props}
      type={'text'}
      value={formattedValue}
      onChange={newValue => {
        if (props.onChange) {
          props.onChange(deformatValue(newValue) || '');
        }
        setFormattedValue(newValue);
      }}
      onBlur={() => {
        setFormattedValue(formatValue(props.value));
      }}
    />
  );
};

function formatValue(value: string | undefined): string | undefined {
  if (value) {
    return displayPhoneNumber(value);
  } else {
    return undefined;
  }
}

function deformatValue(value: string | undefined): string | undefined {
  if (value) {
    return value.replaceAll(/[^0-9]/g, '');
  } else {
    return undefined;
  }
}
